import { useAction } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { goBackAction } from '@root/features/routing/atoms'
import { useBreakpoint } from '@root/shared/hooks/useBreakpoint'
import { ArrowLeftIcon } from '@root/shared/ui-kit'

type Props = {
  title: React.ReactNode
  premium?: boolean | undefined
}

export const PremiumHeader: React.FC<Props> = ({ title, premium = false }) => {
  const goBack = useAction(goBackAction)

  const breakpoint = useBreakpoint()

  return (
    <Root>
      <Button
        onClick={goBack}
        variant="secondary"
        iconLeft={<ArrowLeftIcon />}
        size={breakpoint === 'mobile' ? 'xs' : 's'}
      />
      <Title $premium={premium}>{title}</Title>
    </Root>
  )
}

const Root = styled.nav`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-inline: 12px;
  padding-block: 16px 12px;

  align-items: center;
  justify-content: space-between;
`

const Title = styled.span<{ $premium: boolean | undefined }>`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`
